module.exports = __webpack_public_path__ + "static/media/Card.f1598f0c.svg";